var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.5C10.088 13.5 13 10.588 13 7C13 3.412 10.088 0.5 6.5 0.499999C2.912 0.499999 8.81921e-07 3.412 5.68248e-07 7C2.54575e-07 10.588 2.912 13.5 6.5 13.5ZM6.5 6.35C6.8575 6.35 7.15 6.6425 7.15 7L7.15 9.6C7.15 9.9575 6.8575 10.25 6.5 10.25C6.1425 10.25 5.85 9.9575 5.85 9.6L5.85 7C5.85 6.6425 6.1425 6.35 6.5 6.35ZM5.85 3.75L7.15 3.75L7.15 5.05L5.85 5.05L5.85 3.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceInformationIcon);
export default __webpack_public_path__ + "static/media/deviceInformationIcon.b29e8581.svg";
export { ForwardRef as ReactComponent };